import { laneLabels, shotBandThresholds } from './constants';
import { getPreviewLane, getShotBand } from './helpers';
import { UiState } from './types';

const bandToneClasses = {
  red: 'border-rose-300/25 bg-rose-400/16 text-rose-50',
  yellow: 'border-amber-300/25 bg-amber-400/16 text-amber-50',
  green: 'border-emerald-300/28 bg-emerald-400/16 text-emerald-50',
} as const;

const outcomeToneClasses = {
  goal: 'border-emerald-300/25 bg-emerald-400/16 text-emerald-50',
  save: 'border-sky-300/25 bg-sky-400/16 text-sky-50',
  miss: 'border-amber-300/25 bg-amber-400/16 text-amber-50',
} as const;

export const getPowerHudReadout = (power: number, uiState: UiState) => {
  const liveBand = getShotBand(power);
  const liveLane = getPreviewLane(uiState.aim);
  const isNeutralAim = uiState.phase === 'aim' && !uiState.chargeActive;
  const statusTone =
    uiState.phase === 'result' && uiState.shot
      ? outcomeToneClasses[uiState.shot.outcome]
      : isNeutralAim
        ? 'border-sky-300/25 bg-sky-400/16 text-sky-50'
        : bandToneClasses[liveBand];
  const statusLabel =
    uiState.phase === 'result' && uiState.shot
      ? uiState.shot.outcome === 'goal'
        ? uiState.shot.perfect
          ? 'Perfect goal'
          : 'Goal'
        : uiState.shot.outcome === 'save'
          ? 'Saved'
          : uiState.shot.missKind === 'high'
            ? 'Over the bar'
            : 'Wide'
      : isNeutralAim
        ? 'Ready'
        : power <= shotBandThresholds.redLowMax
          ? 'Too soft'
          : power >= shotBandThresholds.redHighMin
            ? 'Too hard'
            : liveBand === 'green'
              ? 'Perfect window'
              : power < shotBandThresholds.greenStart
                ? 'Build power'
                : 'Ease off';
  const laneLabel = uiState.phase === 'result' && uiState.shot ? laneLabels[uiState.shot.lane] : laneLabels[liveLane];
  const helperCopy = uiState.actionEnabled
    ? uiState.chargeActive
      ? 'Release to shoot'
      : 'Hold to charge'
    : uiState.phase === 'flight'
      ? 'Shot in flight'
      : uiState.phase === 'result'
        ? 'Result locked'
        : uiState.phase === 'summary'
          ? 'Run complete'
          : 'Run-up';

  return { helperCopy, laneLabel, liveBand, statusLabel, statusTone };
};
